<p-toast></p-toast>
<div class="layout-topbar">
    <a class="layout-topbar-logo flex" routerLink="" style="color:#4338ca;font-family: 'Poppins', sans-serif;font-weight:bold; font-size:2em;" >
      <span style="width: 100%;padding-left:1em;">
        Zionn.ai(admin)
      </span>
    </a>
    <button #topbarmenubutton class="p-link layout-topbar-menu-button layout-topbar-button" (click)="layoutService.showProfileSidebar()">
        <i class="pi pi-ellipsis-v"></i>
    </button>
    <button #menubutton class="p-link layout-menu-button layout-topbar-button" (click)="layoutService.onMenuToggle()">
        <i class="pi pi-bars"></i>
    </button>

    <button #topbarmenubutton class="p-link layout-topbar-menu-button layout-topbar-button" (click)="layoutService.showProfileSidebar()">
        <i class="pi pi-ellipsis-v"></i>
    </button>


    <div #topbarmenu class="layout-topbar-menu" [ngClass]="{'layout-topbar-menu-mobile-active': layoutService.state.profileSidebarVisible}">

        <!-- <div style="width: 10vh;margin-right: 10vh;">
            <p-button [rounded]="true" [text]="true" (onClick)="ShowNotifications($event)" *ngIf="loadedInit">
                <i class="pi pi-bell text-3xl" pBadge [value]="listNotification.length" *ngIf="!showNotification && listNotification.length<1" ></i>
                <i class="pi pi-bell text-3xl" pBadge [value]="listNotification.length" *ngIf="!showNotification && listNotification.length>=1" style="color: rgb(255, 165, 0)"></i>
                <i class="pi pi-bell text-3xl" pBadge [value]="listNotification.length" *ngIf="showNotification" style="color: rgb(180, 127, 28)"></i>
            </p-button>
            <div style="position: fixed; padding:0 0 1rem 0;max-height:80vh;overflow-y:auto;" *ngIf="showNotification" class="card">
                <div *ngIf="showNotification" style="width: 0;
                height: 0;
                margin-bottom: 1.5rem; ">
                 <li
                 class="flex justify-content-between align-items-center px-3 p-3 mb-3 cursor-pointer"

                    >
                 <h6 class="m-0 font-semibold" style="margin-right: 2em;">Notificações &nbsp;&nbsp;</h6>
             </li>
                </div>
                <div style="width: 100%;height: 1em;border-bottom: 1px solid #ccc;"></div>
                <ul class="list-none p-0 m-0" style="display: flex;flex-direction: column;justify-content: center; align-items: center; text-align: center;">
                    <div style="flex-direction: column; align-items: center; justify-content: center; width: 80%; margin-top:1rem" class="flex" *ngIf="listNotification.length==0">
                        <div>
                          <ng-lottie [options]="animationNotFound"  width="15em" height="15em"/>

                        </div>
                        <div class="flex" style="justify-content: center;align-items:center;flex-direction:column">
                          <div>
                            Não há novas
                          </div>
                          <div>
                            notificações
                          </div>
                      </div>
                    </div>
                    <li *ngFor="let notification of listNotification">
                        <div [style]="{borderBottom: '1px solid #ccc'}"  >
                            <a
                            class="py-2 px-3 flex gap-2 cursor-pointer hover:text-primary">
                            <div
                                class="flex align-items-center justify-content-center border-1 border-circle border-transparent text-500"
                                style="height: 30px; width: 30px"
                            >
                                <i class="pi pi-bell " [style]="{color: notification.color}"></i>
                            </div>
                            <div>
                                <h6 class="m-0 font-semibold">
                                    {{notification.title}}
                                </h6>

                                <span class="text-sm text-700"
                                    >{{notification.description}}
                                    <span class="font-semibold"
                                        >
                                        <p>
                                            {{ notification.moment?_hourFormatService.utcTolocal(notification.moment.toString()):''}}
                                        </p>
                                        </span
                                    ></span>
                            </div>
                            <div>
                                <p-button icon="pi pi-times" [rounded]="true" severity="danger"  [text]="true"  (onClick)="RemoverNotificacao(notification.id)"/>
                            </div>
                        </a>
                        </div>

                    </li>
                </ul>
            </div>
        </div> -->

        <button class="p-link layout-topbar-button" *ngIf="loadedInit" >
            <!-- <div ></div> -->
            <!-- <i  ></i> -->
            <div class="flex" style="align-items: center; justify-content: center;" *ngIf="!userPicture && loaded" id="userProfile">
                <img src="../../assets/defaultUser.jpg" alt="User Default Image"  style="max-height: 100%;" (click)="op.toggle($event)">
            </div>
            <div class="flex" style="align-items: center; justify-content: center;" *ngIf="userPicture && loaded" id="userProfile">
                <img [src]="userPicture"  alt="Foto de Perfil" style="max-height: 100%;" (click)="op.toggle($event)"  >
            </div>
            <span>Sig In</span>
            <p-overlayPanel #op [style]="{minHeight: '10vh', minWidth:'10vw'}" >
                <div style="width: 100%;height: 5vh;cursor:pointer; margin: 0; padding: 0.5rem; border-radius:6px" class="overlayButton" (click)="ShowDialogUserPreferences()">
                    <i class="pi pi-cog" style="font-size:1rem"></i>
                    <span style="font-size:1rem">Preferências</span>
                </div>
                <div style="width: 100%;height: 5vh;cursor:pointer;margin: 0; padding: 0.5rem; border-radius:6px"  (click)="logOut()" class="overlayButton" >
                    <i class="pi pi-sign-in" style="font-size:1rem"></i>
                    <span style="font-size:1rem">Sair</span>
                </div>
            </p-overlayPanel>
        </button>
    </div>
</div>

<p-dialog [(visible)]="showDialogUserPreferences" [draggable]="false" [closable]="true" [modal]="true" [style]="{minWidth: '30vw', minHeight:'30vh', margin:'0'}" [maximizable]="false" >
    <!-- <div class="col-12" style="padding:0; margin:0">
        <h4 class="font-bold text-lg">Preferências do Usuário</h4>
    </div> -->
    <div class="flex" style="width: 100%; height:30vh; justify-content: center; align-items: center; overflow: hidden;" *ngIf="updating">
        <p-progressSpinner ariaLabel="loading" />
    </div>
    <div class="col-12 flex" id="imagemUser" style="padding:0; justify-content: space-between;" *ngIf="!updating">
        <div class="col-12 flex flex-column">
            <label class="col-12 text-lg font-semibold" for="" style="border-bottom: 1px solid #c7c7c7;">Dados Usuário</label>
            <div class="col-12 flex" style="justify-content: space-between; ">
                <div class="col-6 flex">
                    <div id="cardCabecalho" *ngIf="userPicture" style="display: flex; align-items: center; justify-content: center; ">
                        <div  style="display: flex; align-items: center; justify-content: center; overflow: hidden;">
                            <img class="fotoPerfil" [src]="userPicture" alt="cabecalho" style="height:4rem;">
                        </div>
                        <p-fileUpload
                            mode="basic"
                            name="demo[]"
                            chooseIcon="pi pi-pencil"
                            class="edit-icon"
                            accept=".png" maxFileSize="5000000"
                            (onSelect)="onFileSelect($event)"
                            [auto]="true"
                            [style]="{backgrounColor:'transparent',borderRadius:'6rem'}"
                        ></p-fileUpload>

                    </div>
                    <div *ngIf="!userPicture" id="cardCabecalho" style="display: flex; align-items: center; justify-content: center; ">
                        <p-avatar icon="pi pi-user" shape="circle" size="large" styleClass="avatar"></p-avatar>
                        <p-fileUpload
                            mode="basic"
                            name="demo[]"
                            chooseIcon="pi pi-pencil"
                            class="edit-icon"
                            accept=".png" maxFileSize="5000000"
                            (onSelect)="onFileSelect($event)"
                            [auto]="true"
                            [style]="{backgrounColor:'transparent',borderRadius:'6rem'}"
                        ></p-fileUpload>

                    </div>

                    <div class="col-8 flex flex-column" id="userData" *ngIf="usuario">
                        <label class="text-lg font-semibold" for="">{{usuario.name}}</label>
                        <label class="text-sm" for="">{{usuario.email}}</label>
                    </div>
                </div>
                <div class="col-6 flex flex-column" style=" height: 90%; justify-content: space-around;">
                    <label class=" text-medium font-semibold" for="">Modo de Tela:</label>
                    <div class=" flex" style="justify-content: flex-start; width: 100%;">
                        <p-dropdown
                            optionValue="code"
                            optionLabel="label"
                            [options]="temasDisponiveis"
                            [(ngModel)]="themechoose"
                            (onChange)="changeThemeCartsy()"
                            filterBy="label" >
                        </p-dropdown>
                        <!-- <p-button icon="pi pi-moon" [outlined]="true" [rounded]="true" [style]="{marginRight:'2rem'}" [disabled]="theme != 'lara-light-purple'" (onClick)="changeThemeCartsy()"></p-button> -->
                        <!-- <p-button icon="pi pi-sun" [outlined]="true" [rounded]="true" (onClick)="changeThemeCartsy()" [disabled]="theme == 'lara-light-purple'"></p-button> -->
                    </div>
                </div>
            </div>

            <div class="col-12">
                <p-button icon="pi pi-key" [style]="{width:'100%'}" label="Trocar de Senha" (onClick)="showChangePasswordDialog=true"></p-button>
            </div>

            <div class="col-12 flex" style="justify-content: flex-end; margin-bottom: 0;padding-bottom:0;">
                <p-button label="Salvar" (onClick)="AtualizarPreferencias()" [disabled]="!validChange"></p-button>
            </div>
        </div>

    </div>
</p-dialog>

<p-dialog header="Mudar Senha" [(visible)]="showChangePasswordDialog" [draggable]="false" [closable]="true" [modal]="true" [style]="{minWidth: '30vw', minHeight:'40vh'}" [maximizable]="false" >
    <div *ngIf="showChangePasswordDialog">
        <div class="flex flex-column justify-content-center gap-3 align-items-center" [formGroup]="form">
            <div class="w-full flex gap-2 justify-content-center mt-3" style=" width: 100%;">
                <label for="" class="text-lg font-bold">Email:</label>
                <span class="text-lg">{{usuario.email}}</span>
            </div>
        
            <div class="w-full flex gap-2 justify-content-center align-items-center">
                <label for="" class="text-lg font-bold">Nova Senha:</label>
                <p-password 
                formControlName="password"
                [toggleMask]="true" 
                id="inputPassword"/>
            </div>
        
            <div class="col-12" style="width: 100%; display: flex; justify-content: flex-end;">
                <p-button [outlined]="true" label="Cancelar" (onClick)="showChangePasswordDialog = false"></p-button>
                <p-button label="Salvar" [style]="{marginLeft:'1rem'}" (onClick)="mudarSenha()"></p-button>
            </div>
        </div>
    </div>
</p-dialog>

<p-dialog header="Obter Créditos" [(visible)]="showDialogCredits" [draggable]="false" [closable]="true" [modal]="true" [style]="{minWidth: '40vw', minHeight:'40vh'}" [maximizable]="false" >
    <div class="flex" style="width:94%; justify-content: flex-end;margin-top: 1rem;">
        <span class="text-lg font-bold" style="color: #EF4444;">Saldo: {{credities.toFixed(0)}}</span>
    </div>
    <div class="col-12 flex" style="max-width:50vw;align-items: center; justify-content: space-around; margin-top:1rem">
        <div class="card col-3 flex flex-column" style="align-items: center; ">
            <span class="text-sm font-semibold" style="width:100%; text-align: end;">R$39,90</span>
            <img src="../../assets/1coin.png" alt="" style="width:100%;">
            <div class="col-12 flex flex-column align-items-center">
                <span class="text-lg font-bold">Plus</span>
                <span class="text-medium font-semibold" style="color:green">100 créditos</span>
            </div>
            <p-button label="Escolher" [disabled]="true" severity="info" id="botaoCredits"></p-button>
        </div>
        <div class="card col-3 flex flex-column" style="align-items: center; ">
            <span class="text-sm font-semibold" style="width:100%; text-align: end;">R$149,90</span>
            <img src="../../assets/2coin.png" alt="" style="width:100%;">
            <div class="col-12 flex flex-column align-items-center">
                <span class="text-lg font-bold">Gold</span>
                <span class="text-medium font-semibold" style="color:green">1.000 créditos</span>
            </div>
            <p-button label="Escolher" [disabled]="true" severity="info" id="botaoCredits"></p-button>

        </div>
        <div class="card col-3 flex flex-column" style="align-items: center;">
            <span class="text-sm font-semibold" style="width:100%; text-align: end;">R$289,00</span>
            <img src="../../assets/3coin.png" alt="" style="width:100%;">
            <div class="col-12 flex flex-column align-items-center">
                <span class="text-lg font-bold">Premium</span>
                <span class="text-medium font-semibold" style="color:green">10.000 créditos</span>
            </div>
            <p-button label="Escolher" [disabled]="true" severity="info" id="botaoCredits"></p-button>
        </div>
    </div>

    <div class="flex" style="width:94%; justify-content: flex-end;">
        <p-button [outlined]="true" label="Voltar" (onClick)="ShowDialogCredits()"></p-button>
    </div>
</p-dialog>
